module.exports = {
    system: {
    	version:"V1.0.1",
    	company:"青岛迪迪网络科技有限公司",
    	companyUrl:"http://www.didigps.com/"
    },
    buildPath: {
    	server:"http://192.168.1.35/iov"
    }
};


// WEBPACK FOOTER //
// ./src/config/config.js